import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DISH_QA_DATES_BY_QA_QUERY } from '../graphql/queries'
import { FETCH_DISH_QA_DATES } from '../redux/action-types'

const useDishQaDatesLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    qaDates: data,
    isQaDatesLoading: isLoading,
    qaDatesError: error,
  } = useSelector(store => store.dishes.dishes)

  const fetch = useCallback(
    (menuId, qaIds) =>
      apolloService.query({
        query: DISH_QA_DATES_BY_QA_QUERY,
        variables: {
          menuId,
          qaIds,
        },
        dispatch,
        action: FETCH_DISH_QA_DATES,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useDishQaDatesLazyQuery
